//API serivice FUNCTIONS
import { current } from "@reduxjs/toolkit";
import { filterByChoice, getFromLocalStorage, lengthChecker, setToLocalStorage } from "../../Helpers/helpers";
import { changeHall, changeLine, changeMachine, changePlant, changePlants, changeShift, clearPlant, setCurrentPlant, setPlantsList } from "../../Redux/features/plant.slice";
import { clearLoaders, setLoader, setPageLoader } from "../../Redux/features/utils.slice";
import { login } from "../../Redux/features/auth.slice";
import { getRequest, postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"
import { success } from "../../Helpers/notification";
import { getRolesList } from "./roles.api";
import moment from "moment-timezone";
const { plants } = apiRoutes;

const getAllPlants = async (dispatch, selector) => {
    let existingData = JSON.parse(localStorage.getItem('plants'))
    //Check if the data already exists ( This runs only once )
    dispatch(setLoader(true))
    if (!existingData)
        existingData = await onInitialLoad()

    //Setting Values 
    let plantData = existingData
    const halls = JSON.parse(localStorage.getItem('halls'))
    const lines = JSON.parse(localStorage.getItem('lines'))
    const machines = JSON.parse(localStorage.getItem('machines'))
    const user = JSON.parse(localStorage.getItem('user'))
    dispatch(login(user))
    // console.log({ current: JSON.parse(localStorage.getItem('current')) })
    
    let current = {
        plant: !!plantData ? plantData[0] : undefined,
        hall: !!halls ? halls[0] : undefined,
        line: !!lines ? lines[0] : undefined,
        machine: (lines && lines[0]?.machines?.length && lines[0]?.machines) ? lines[0]?.machines[0] : { machineName: 'default', displayName: 'Default Machine' },
        shift: !!lines ? lines[0]?.shifts[0] : undefined
    }
    if(!localStorage.getItem('current'))
    setToLocalStorage(current, 'current')
    dispatch(setPlantsList(
        {
            allPlants: plantData,
            halls,
            lines,
            machines,
            current: JSON.parse(localStorage.getItem('current'))
        }
    ))
    dispatch(setLoader(false))
}

const currentShiftFor = function(shifts) {
    const timeNow = moment(new Date())
      .toDate();
    return shifts.reduce((result, shift) => {
      let fromTime = convertTimeString({ string: shift.from, day: timeNow });
      let toTime = convertTimeString({ string: shift.to, day: timeNow });
  
      // if ending time is of after midnight
      if (moment(toTime).isBefore(fromTime)) {
        // if current time is after midght
        if (moment(fromTime).isAfter(moment(timeNow))) {
          fromTime = moment(fromTime)
            .subtract(1, 'day')
            .toDate();
        } else {
          toTime = moment(toTime)
            .add(1, 'day')
            .toDate();
        }
      }
  
      if (moment(fromTime).isBefore(timeNow) && moment(toTime).isAfter(timeNow)) {
        result = {
          fromTime,
          toTime,
          ...shift,
        };
      }
      return result;
    }, false);
  };

const onPlantChange = async (values, dispatch, setShowAddPlantModal, setModalTitle) => {
    
    if(values?.data?._id == 'addPlantOption'){
        setModalTitle('Add Plant');
        setShowAddPlantModal(true);
        return;
    }
    dispatch(setLoader(true));
    let machines;
    let halls = values.data?.productionLines?.map((line, index) => ({
        hallName: line?.hallName,
        lineId: line?.id,
        index,
    }));
    //halls = [...new Set(lines?.map(item=> item.hallName))]

    let { selectedLine, lines = [] } = await getSelectedLine(values?.data?._id, halls[0]?.lineId);

    halls = [...new Set(lines?.map(item=> item.hallName))];
    halls = halls.map((line, index) => ({
        hallName: line,
        index,
    }));
    machines = (selectedLine[0]?.machines && selectedLine[0]?.machines?.length)
        ? selectedLine[0]?.machines
        : [];
    let defaultname = selectedLine[0] && selectedLine[0].defaultLineName ? selectedLine[0].defaultLineName:null
    machines = [{ machineName: 'default', displayName: defaultname?('Default - '+defaultname):'Default Machine' }, ...machines];

    setToLocalStorage(halls, 'halls');
    setToLocalStorage(lines, 'lines');
    setToLocalStorage(machines, 'machines');

    let current = {
        plant: values?.data,
        hall: halls[0],
        line: selectedLine[0],
        machine: machines[0], 
        shift: selectedLine[0]?.shifts[0],
    };

    setToLocalStorage(current, 'current');

    dispatch(changePlant({
        halls,
        lines,
        machines,
        current,
    }));

    dispatch(setLoader(false));
};

const onInitialLoad = async () => {
    let response = await postRequest({ endPoint: plants.getAll })
    console.log({ response })
    setToLocalStorage(response?.response, 'plants')
    let halls = [];
    response?.response[0]?.productionLines?.map((line, index) => {
        halls.push({ hallName: line?.hallName, lineId: line?.id, index })
    })
    // console.log({ plants: response, halls })
    let { selectedLine, lines } = await getSelectedLine(response?.response[0]?._id, halls[0]?.lineId)
     halls = Array.isArray(lines)
    ? [...new Set(lines.map(item => item.hallName))]
    : [];
    halls = halls.map((line, index) => ({
        hallName: line,
        index,
    }));
    let defaultLine = selectedLine?.[0]
    let defaultname = defaultLine && defaultLine.defaultLineName ? defaultLine.defaultLineName:null
    let defaultMachine = { machineName: 'default', displayName: defaultname?('Default - '+defaultname):'Default Machine' }
    if (defaultLine)
        defaultLine.machines = [defaultMachine].concat(defaultLine.machines?defaultLine.machines:[]);
    let current = {
        plant: response?.response[0],
        hall: halls[0],
        line: defaultLine,
        machine: defaultLine?.machines?.[0] || defaultMachine,
        shift: defaultLine?.shifts?.length ? defaultLine.shifts[0] : null
    }
    setToLocalStorage(halls, 'halls')
    setToLocalStorage(lines, 'lines')
    setToLocalStorage(defaultLine?.machines?.length ? defaultLine.machines : [defaultMachine], 'machines')
    setToLocalStorage(current, 'current')
    return response?.response
}

const convertTimeString = ({ string, day }) => {
    const split = string.split(':');
  
    if (split.length < 2) {
      console.log('Incorrect time format', string);
      return;
    }
  
    return moment(day)
      .startOf('day')
      .add(split[0], 'hours')
      .add(split[1], 'minutes')
      .toDate();
  };

  const getSelectedLine = async (plantId, lineId) => {
    try {
        console.log('get selected line')

        let productionLines = await postRequest({
            endPoint: plants.getProductionLine,
            body: { "conditions": { "_id": plantId, "machine": null }, "attributes": undefined }
        });

        console.log('production lines', productionLines)

        setToLocalStorage(productionLines, 'lines');

        let selectedLine = Array.isArray(productionLines?.response) 
            ? filterByChoice(productionLines.response, 'id', lineId)
            : null;

        console.log({ selectedLine, productionLines });
        return { selectedLine, lines: productionLines.response };
    } catch (error) {
        console.error("Error fetching or filtering production lines:", error);
        throw error;
    }
};



const onDropDownChange = (values, dispatch, type, setShowAddPlantModal, setModalTitle) => {
    let current = JSON.parse(localStorage.getItem('current'))
    // Change Hall
    if (type == 1) {
        current = { ...current, hall: values.data }
        dispatch(changeHall({
            selectedHall: values.data
        }))
    }
    // Change Line
    if (type == 2) {
        if (values?.data?.id === 'addLineOption') {
            setModalTitle('Add Line');
          setShowAddPlantModal(true);
        } else{
            console.log("Line: ", values, "Machines: ", values?.data?.machines)
            let defaultname = values?.data && values?.data?.defaultLineName ? values?.data?.defaultLineName:null
            let lineMachines = [{ machineName: 'default', displayName: defaultname?('Default - '+defaultname):'Default Machine' }].concat(values.data.machines?values.data.machines:[]);
            let selectedMachine = (lineMachines?.length && lineMachines?.machines) ? lineMachines?.machines[0] : { machineName: "default", displayName: "Default Machine" }
            current = {
                ...current,
                line: values.data,
                machine: selectedMachine,
                shift: values?.data?.shifts?.length ? values?.data?.shifts[0] : null
            }
            dispatch(changeLine({
                selectedLine: values.data,
                selectedMachine,
                machines: lineMachines//(values.data.machines && values.data.machines?.length) ? values.data.machines : [{ machineName: "default", displayName: "Default Machine" }]
            }))
            setToLocalStorage((lineMachines && lineMachines) ? lineMachines : [{ machineName: "default", displayName: "Default Machine" }], 'machines')
    }
    }
    // Change Machine
    if (type === 3) {
        if (values?.data?.machineName === 'addMachineOption') {
            setModalTitle('Add Machine');
          setShowAddPlantModal(true);
        } else {
            current = { ...current, machine: values.data }
            dispatch(changeMachine({
                selectedMachine: values.data
            }))
        }
      }
    // Change Shift
    if (type == 4) {
        dispatch(changeShift({
            selectedShift: values.data
        }))
    }
    setToLocalStorage(current, 'current')
}



// SiteChampion Form Submit
const onSiteChampionSubmit = async (dispatch, body) => {

    dispatch(setPageLoader({ page: 'siteChampion', flag: true }))

    let response = await postRequest({
        endPoint: plants.update,
        body
    })
    dispatch(setPageLoader({ page: 'siteChampion', flag: false }))

    if (response.success === true) {
        success("Plant updated")
    }


}

const updatePlants = (plant, plantId, dispatch) => {
    let plants = getFromLocalStorage('plants')
    let current = getFromLocalStorage('current')
    current = { ...current, plant }
    let filteredPlants = plants.filter(plant => plant._id !== plantId)
    let newPlants = [...filteredPlants, plant]
    dispatch(changePlants({ newPlant: plant, newPlants }))
    setToLocalStorage('plants', newPlants)
    setToLocalStorage('current', current)
}

const updateAllPlants = (plant, plants, dispatch) => {
    let current = getFromLocalStorage('current')
    let currentPlant = plants.filter(item => item._id === plant._id)[0]
    current = { ...current, plant: currentPlant }
    dispatch(changePlants({ newPlant: currentPlant, newPlants: plants }))
    setToLocalStorage('plants', plants)
    setToLocalStorage('current', current)
}

const onChangeHandler = async (values, key, handlers, dispatch) => {
    dispatch(setPageLoader({ page: 'auditTrails', flag: true }))
    let { setters, getters } = handlers;
    // On Change in Plant ( Production Lines and Halls need to be changed as well )
    if (key == 'plant') {
        let plantId = values?.data?._id
        let { lines = [] } = await getProductionLinesForPlant(plantId)
        let halls = lines?.map((line, index) => ({ hallName: line?.hallName, lineId: line?.id, index }))
        setters?.list(prev =>
        ({
            ...prev,
            lines: lengthChecker(lines),
            halls: lengthChecker(halls),
            shifts: lengthChecker(lines?.shifts),
        }))
        setters?.current(prev =>
        ({
            plant: plantId,
            line: lines[0]?.id,
            hall: halls[0]?.hallName,
            shift: lines?.shifts?.length ? lines?.shifts[0]?.name : null,
            reason: 1,
        }))
    }
    // On Change in Hall ( Only Hall needs to be changed )
    if (key == 'hall') {
        setters?.current(prev =>
        ({
            ...prev,
            hall: values?.data?.hallName
        }))
    }
    // On Change in Line ( Shifts need to be changed as well )
    if (key == 'line') {
        setters?.list(prev => ({ ...prev, shifts: lengthChecker(values?.data?.shifts) }))
        setters?.current(prev =>
        ({
            ...prev,
            line: values?.data?.id,
            shift: values?.data?.shifts?.length ? values?.data?.shifts[0]?.name : null
        }))
    }
    // On Change in Shifts ( Only Shift needs to be changed )
    if (key == 'shift') {
        setters?.current(prev =>
        ({
            ...prev,
            shift: values?.data?.name
        }))
    }
    if (key == 'reason') {
        setters?.current(prev =>
        ({
            ...prev,
            reason: values?.data?.name
        }))
    }
    setters?.setLogs([])
    return dispatch(setPageLoader({ page: 'auditTrails', flag: false }))
}

const getProductionLinesForPlant = async (plantId, lineId) => {
    //Getting Production Lines by Plant ID
    
    let productionLines = await postRequest({
        endPoint: plants.getProductionLine,
        body: { "conditions": {"_id": plantId, "machine": null}, "attributes": undefined }
            // `{%22_id%22:%22${plantId}%22,%22machine%22:null}&attributes=undefined}`
    })

    console.log('productionLines', productionLines)
    return { lines: productionLines?.response }
}

const clearStorage = (dispatch) => {
    localStorage.clear()
    dispatch(clearPlant())
    dispatch(clearLoaders())
}


export {
    getAllPlants,
    onPlantChange,
    onDropDownChange,
    onSiteChampionSubmit,
    updatePlants,
    updateAllPlants,
    onChangeHandler,
    clearStorage,
    getSelectedLine
}